export default __webpack_public_path__ + "static/media/RoomTestImg1.5b59bb9a.png";